export enum WebhookMethod {
  Get = 'get',
  Post = 'post',
}
